'use strict';

function assertArgument(exists) {
  if (!exists) {
    throw new TypeError('Argument required');
  }
}

module.exports = assertArgument;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/assertArgument.js
// module id = 251
// module chunks = 0